<div
  class="overflow-x-auto pl-2 pr-3 pt-2"
  style="min-height: 400px"
  [ngClass]="{ spinner: ciiTracks === undefined }">
  <highcharts-chart
    *ngIf="ciiTracks"
    [Highcharts]="Highcharts"
    [options]="ciiOptions"
    style="width: 100%; height: 400px; display: block"
    (chartInstance)="chartRef = $event">
  </highcharts-chart>
</div>
